@switch (columnName) {
  @case ('user') {
    {{ element.user?.name }} {{ element.userName }}
  }
  @case ('date') {
    {{ element.date | date: dateTimeFormat }}
  }
  @case ('to') {
    {{ element.to | timeDisplay }}
  }
  @case ('from') {
    {{ element.from | timeDisplay }}
  }
  @default {
    {{ element[columnName] }}
  }
}
